function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { SvgIcon } from '@material-ui/core';
export default function GoogleIcon(props) {
  let path = /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/React.createElement("title", null, "Ic\xF4ne Google"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M522.88 202.666c75.52 0 143.148 26.027 196.48 76.8l146.133-146.133c-88.747-82.56-204.588-133.333-342.613-133.333-200.108 0-373.121 114.773-457.388 282.028l170.24 132.053c40.32-121.388 153.6-211.413 287.148-211.413z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M1013.121 523.732c0-33.493-3.2-65.92-8.107-97.068h-482.134v192.428h276.053c-12.373 63.147-48.213 116.908-101.973 153.173l164.908 128c96.213-89.173 151.253-221.013 151.253-376.533z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M235.519 609.919c-10.24-30.933-16.213-63.787-16.213-97.92s5.76-66.987 16.213-97.92l-170.24-132.053c-34.773 69.12-54.4 147.2-54.4 229.973s19.627 160.853 54.613 229.973l170.028-132.053z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M522.88 1024c138.24 0 254.508-45.44 338.988-123.948l-164.908-128c-45.867 30.933-104.96 49.067-174.080 49.067-133.548 0-246.828-90.027-287.361-211.413l-170.24 132.053c84.48 167.468 257.493 282.241 457.601 282.241z"
  })));
  return path;
}
